<template>
  <div class="sessionbtnform">
    <el-popover
      placement="right"
      title="Contáctanos"
      content="Para mas información."
      :width="200"
      trigger="hover"
    >
      <template #reference>
        <a v-on:click="contactanos()" class="btnForm mt-5 elemento">
          <img
            src="@/assets/images/contact-form-1.png"
            class="elemento"
            style="width: 60px"
          />
          <!-- <div
            class="text-center"
            style="font-size: 18px; font-weight: bold; color: brown"
          >
            ¿Tienes una consulta? Escríbenos
          </div> -->
        </a>
      </template>
    </el-popover>
  </div>
</template>

<script>
const $ = require("jquery");
require("@geodir/geodir-js/src/Geodir");
//autenticacion
import loginService from "./services/loginService";

var _geo = new Geodir();

export default {
  data() {
    return {
      user: {},
      message: "Header",
      type: "geodir",
      access_token: "",
      navigatorInMobile: false,
    };
  },
  created() {
    var checkNavigator = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        checkNavigator = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    this.navigatorInMobile = checkNavigator;
  },
  computed: {
    checkLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  mounted: function () {
    let app = this;
    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      app.getUser();
    });

    if (app.checkLogin) {
      app.getUser();
    }
  },
  methods: {
    contactanos() {
      console.log("contactanos");
      console.log(this.$route.fullPath);
      let actualRoute = this.$route.fullPath;
      let params = {};

      let url = process.env.VUE_APP_URL_REDIRECT_CONTACTO_URL;

      url = url.substring(url, url.length - 1);

      console.log(url.substring(url, url.length - 1));

      //this.$router.push(actualRoute+"/contact");
      window.location.href = "contact";
    },
    logout() {
      var app = this;
      let loginRedirect = {
        path: this.$route.path,
        query: this.$route.query,
        params: this.$route.params,
      };
      localStorage.setItem("LOGINREDIRECT", JSON.stringify(loginRedirect));

      localStorage.removeItem("geodir_Token");
      _geo.setAccessToken(null);
      app.$store.state.isLoggedIn = false;
      app.$router.push(loginRedirect);

      window.location.href = process.env.VUE_APP_URL_REDIRECT_URL_PRINCIPAL;

      //window.location.href = "https://maps.geodir.co/";
    },
    getUser: function () {
      console.log("OBTENER USUARIO");

      let app = this;
      if (app.checkLogin) {
        let token = JSON.parse(localStorage.getItem("geodir_Token"));
        _geo.setAccessToken(token.data.access_token);
        app.access_token = token.data.access_token;

        console.log("token obtenido");
        console.log(app.access_token);

        loginService
          .user(app.access_token)
          .then(function (res) {
            if (res.status === "success") {
              console.log("usuario info");
              console.log(res.data);
              app.$store.state.user = res.data;

              window.localStorage.setItem("user", JSON.stringify(res.data));
            } else {
              app.$store.state.user = {};
            }
            app.user = app.$store.state.user;
          })
          .catch(function (err) {
            app.$store.user = {};
            console.log("ERRORRR");
            console.log(err);
          });
      }
    },
  },
};
</script>

<style>
.sessionbtnform {
  position: fixed;
  z-index: 10000;
  right: 0;
  bottom: 200px;
  padding: 5px;
}
.btnForm {
  width: 60px;
  font-size: 12px !important;

  transition: all 0.001s ease-in-out !important;
}
.btnForm:hover {
  border-color: #0570f4 !important;

  position: relative;
  cursor: pointer;
}
.users {
  background-color: #2164f9;
  color: #fff;
  display: block;
  float: left;
  height: 40px;
  margin: 0 4px 4px 0;
  overflow: visible;
  position: relative;
  width: 40px;
  user-select: none;
  z-index: 0;
  border-radius: 25em;
}
.users-initials {
  display: block;
  font: 15px Arial, sans-serif;
  font-weight: 700;
  height: 40px;
  left: 0;
  line-height: 40px;
  overflow: hidden;
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;
}
.logout {
  border-radius: 0px !important;
  border: 0px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 -1px 0px rgba(0, 0, 0, 0.02);
}
.fontSize {
  font-size: 11px;
}
.contents {
  padding: 15px !important;
  width: 300px;
}

@media (max-width: 420px) {
  .contents {
    padding: 15px 0 !important;
    min-width: 280px !important;
    margin-left: -128px !important;
    min-height: 200px;
  }
  .sessionbtnform {
    margin-top: 10px;
    padding: 0px;
    right: 0px;
    z-index: 1000;
  }
  .display {
    display: none;
  }
  .users {
    display: inline-block;
    float: none;
    text-align: center;
  }
}
@keyframes pulso {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.elemento {
  animation: pulso 1s infinite;
}
/*@media (max-width: 420px) {
  .contents{
    padding: 15px 0!important;
    min-width: 280px !important;
    margin-left: -128px !important;
    min-height: 200px;
    
  }
  .sessionbtnform {
    margin-top: 70px;
    padding: 0px; 
    z-index: 1000;
  }
  .display {
    display: none;
  }
  .users{

      display: inline-block;
      float: none;
      text-align: center;
  }
}*/
</style>
